const normalizeString = (str) => {
    if (!str) return '';
    return str.toLowerCase().trim()
        .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
        .replace(/đ/g, 'd').replace(/Đ/g, 'D')
        .replace(/[^a-z0-9]/g, "");
};

const calculateSimilarity = (s, t) => {
    if (!s || !t) return 0;
    if (s === t) return 1;

    const maxLength = Math.max(s.length, t.length);
    if (maxLength === 0) return 1;

    if (Math.abs(s.length - t.length) / maxLength > 0.1) return 0;

    let v0 = new Array(t.length + 1);
    let v1 = new Array(t.length + 1);

    for (let i = 0; i <= t.length; i++) v0[i] = i;

    for (let i = 0; i < s.length; i++) {
        v1[0] = i + 1;
        for (let j = 0; j < t.length; j++) {
            const cost = s[i] === t[j] ? 0 : 1;
            v1[j + 1] = Math.min(v1[j] + 1, v0[j + 1] + 1, v0[j] + cost);
        }
        for (let j = 0; j <= t.length; j++) v0[j] = v1[j];
    }

    return 1.0 - (v0[t.length] / maxLength);
};

export const detectDuplicates = (items) => {
    if (!items || items.length === 0) return [];

    const THRESHOLD = 0.90;
    let groups = [];
    let visited = new Set();

    const precomputedItems = items.map(item => ({
        ...item,
        _searchTitle: normalizeString(item.Title || item.BookName || '')
    }));

    const exactMatchMap = new Map();
    for (let i = 0; i < precomputedItems.length; i++) {
        const item = precomputedItems[i];
        if (!item._searchTitle) continue;

        if (!exactMatchMap.has(item._searchTitle)) {
            exactMatchMap.set(item._searchTitle, []);
        }
        exactMatchMap.get(item._searchTitle).push(item);
    }

    for (const [title, group] of exactMatchMap.entries()) {
        if (group.length > 1) {
            group.sort((a, b) => new Date(a.CreatedAt || 0) - new Date(b.CreatedAt || 0));
            groups.push(group);
            group.forEach(item => visited.add(item.Id));
        }
    }

    const remainingItems = precomputedItems.filter(item => !visited.has(item.Id) && item._searchTitle.length > 0);

    for (let i = 0; i < remainingItems.length; i++) {
        if (visited.has(remainingItems[i].Id)) continue;

        let currentGroup = [remainingItems[i]];
        let titleI = remainingItems[i]._searchTitle;

        for (let j = i + 1; j < remainingItems.length; j++) {
            if (visited.has(remainingItems[j].Id)) continue;

            let titleJ = remainingItems[j]._searchTitle;

            const maxLength = Math.max(titleI.length, titleJ.length);
            if (Math.abs(titleI.length - titleJ.length) / maxLength > (1 - THRESHOLD)) {
                continue;
            }

            let sim = calculateSimilarity(titleI, titleJ);
            if (sim > THRESHOLD) {
                currentGroup.push(remainingItems[j]);
                visited.add(remainingItems[j].Id);
            }
        }

        if (currentGroup.length > 1) {
            currentGroup.sort((a, b) => new Date(a.CreatedAt || 0) - new Date(b.CreatedAt || 0));
            groups.push(currentGroup);
        }
        visited.add(remainingItems[i].Id);
    }

    return groups;
};